// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LaTribune.css - Animations et styles pour La Tribune */

.la-tribune-container {
    padding: 2rem;
    background-color: #f3f4f6;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .la-tribune-title {
    font-size: 2.5rem;
    font-weight: bold;
    color: #2d3748;
    margin-bottom: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    animation: fadeIn 1s ease-in-out;
  }
  
  .la-tribune-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    max-width: 1000px;
    width: 100%;
  }
  
  .la-tribune-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    animation: slideUp 0.5s ease-in-out;
  }
  
  .la-tribune-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }
  
  .la-tribune-card-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #4a5568;
  }
  
  .la-tribune-card-link {
    color: #3b82f6;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.3s ease-in-out;
  }
  
  .la-tribune-card-link:hover {
    color: #1e40af;
  }
  
  /* Animations */
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/composant/container/LaTribune/LaTribune.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yCAAyC;IACzC,mEAAmE;IACnE,mCAAmC;EACrC;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,cAAc;EAChB;;EAEA,eAAe;;EAEf;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF","sourcesContent":["/* LaTribune.css - Animations et styles pour La Tribune */\n\n.la-tribune-container {\n    padding: 2rem;\n    background-color: #f3f4f6;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .la-tribune-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: #2d3748;\n    margin-bottom: 1.5rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    animation: fadeIn 1s ease-in-out;\n  }\n  \n  .la-tribune-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n    max-width: 1000px;\n    width: 100%;\n  }\n  \n  .la-tribune-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    text-align: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n    animation: slideUp 0.5s ease-in-out;\n  }\n  \n  .la-tribune-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\n  }\n  \n  .la-tribune-card-title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: #4a5568;\n  }\n  \n  .la-tribune-card-link {\n    color: #3b82f6;\n    font-weight: 500;\n    text-decoration: none;\n    transition: color 0.3s ease-in-out;\n  }\n  \n  .la-tribune-card-link:hover {\n    color: #1e40af;\n  }\n  \n  /* Animations */\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes slideUp {\n    from {\n      transform: translateY(20px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
